export enum SettingTabs {
  COMMON = 'Common',
  ACCOUNT = 'Account',
  ANALYTICS = 'Analytics',
}
